import React, { type ReactNode } from "react";
import { cn } from "src/utilities/shadcnUtils";

export interface BasicTableProps {
  children: ReactNode;
  tableClassName?: string;
  overflow?: boolean;
  className?: string;
}

const BasicTable = ({ children, tableClassName, overflow, className }: BasicTableProps) => (
  <div className={cn(className, overflow && "overflow-y-visible")}>
    <div className={cn(overflow && "overflow-x-auto")}>
      <table className={cn("w-full border-collapse h-[1px]", tableClassName)}>{children}</table>
    </div>
  </div>
);

export default React.memo(BasicTable);
